import { useState, useEffect } from   'react';
import { NavLink} from 'react-router-dom';
import DataTable from 'react-data-table-component';
import apiService from '../../Auth/apiService';
import { useForm } from 'react-hook-form';
import SweetAlert2 from 'react-sweetalert2';
import { BotonEditar } from '../Utils/BotonEditar';
import { useAuth } from '../../Auth/AuthContext';

function BotonAcciones(row, handleEdit) {
    return (
        <BotonEditar Editar={handleEdit} row={row} />
    );
}

export default function TipoEntregaxTipoAhu(){
    const { token } = useAuth();
    const [datos, setDatos] = useState([]);
    const [Cargando, setCargando] = useState(false);
    const [tiposAhu, setTiposAhu] = useState([]);
    const [tiposEntrega, setTiposEntrega] = useState([]);
    const { handleSubmit, register, setValue, formState: { errors }} = useForm();
    const [swalProps, setSwalProps] = useState({});
    const [MuestraFormulario, setMuestraFormulario] = useState(false);
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/parametros/guardartipoentregaxtipoahu';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar tipos', JSON.stringify(response.data));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar tipos', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar tipos', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            fetchData();
            ResetForm();
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        setValue('id', 0);
        setValue('tipTipoahuid', '');
        setValue('tipTipoentregaid', '');
        setMuestraFormulario(false);
    }
    const Nuevo = () =>  {
        setValue('id', 0);
        setValue('tipTipoahuid', '');
        setValue('tipTipoentregaid', '');
        setMuestraFormulario(true);
    }

    function handleEdit (row){
        setMuestraFormulario(true);
        setValue('id', row.id);
        setValue('tipTipoahuid', row.tipTipoahuid);
        setValue('tipTipoentregaid', row.tipTipoentregaid);
    };
    const columns = [
        {
            name: 'Acciones',
            cell: row => BotonAcciones( row, handleEdit ),
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'Id', selector: row => row.id, sortable: true, width:'10%' },
        { name: 'Tipo AHU', selector: row => row.tipTipoahu, sortable: true, width: '25%'},
        { name: 'Tipo entrega', selector: row => row.tipTipoentrega, sortable: true, width: '25%' }
        ];

    const fetchData = async () => {
        const url = '/parametros/listartipoentregaxtipoahu';
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
            setTiposAhu(result.tiposahu);
            setTiposEntrega(result.tiposentrega);
            setDatos(result.tipoentregaxtipoahu);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };

    useEffect(() => {
        fetchData();
        }, []);

    return (
        <div className ="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Tipos AHU por Tipos Entrega</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to="/" >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to="/parametros" >Par&aacute;metros</NavLink></li>
                        <li className="breadcrumb-item active"> Tipos AHU por Tipos Entrega</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {MuestraFormulario && <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario Tipos AHU por Tipos Entrega</h3>
                                
                            </div>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    
                                    <input hidden {...register('id')}/>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='tipTipoahuid'>Tipos atenciones</label>
                                                <select
                                                    className="form-control"
                                                    {...register('tipTipoahuid', { required: true })}
                                                >
                                                    <option value="">Seleccione...</option>
                                                    {tiposAhu.map((tipo) => (
                                                        <option key={tipo.id} value={tipo.id}>
                                                            {tipo.tipTipoahu}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.tipAtencion && <p style={{color: 'red'}}>Digitar dato</p>}
                                            </div>  
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='tipTipoentregaid'>Tipos entrega</label>
                                                <select
                                                    className="form-control"
                                                    {...register('tipTipoentregaid', { required: true })}
                                                >
                                                    <option value="">Seleccione...</option>
                                                    {tiposEntrega.map((tipo) => (
                                                        <option key={tipo.id} value={tipo.id}>
                                                            {tipo.tipTipoentrega}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.tipTipoentregaid && <p style={{color: 'red'}}>Digitar dato</p>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className='row'>
                                        <div className='col-md-1'>
                                            <button type="submit" className="btn btn-info">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }   
                    <div className="card card">
                        <div className="card-body">
                            <div className="card-body table-responsive p-0">
                                <button type="button" className='form-control' onClick={Nuevo}>Nuevo</button>
                                <DataTable
                                    title="Lista de tipos ahu por tipos entrega"
                                    columns={columns}
                                    data={datos}
                                    progressPending={Cargando}
                                    pagination
                                    noDataComponent="No hay datos para mostrar"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
        </div>
    );
}